
<template>
  <div
    class="custom-multiselect-style placeholder-italic"
    :class="getParentCustom"
  >
    <multiselect
      v-model="selectedOption"
      :options="availabilityOptions"
      placeholder="Select gender"
      :searchable="false"
      :show-no-results="false"
      :openDirection="below"
      :taggable="false"
      :showLabels="false"
      :show-labels="false"
      @input="updateSelection"
      @change="updateSelection"
    ></multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },
  props: {
    value: {
      type: String,
      default: "Select gender",
    },
    placeholder: {
      type: String,
      default: "Select gender",
    },
    getParentCustom: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      selectedOption: this.value,
      availabilityOptions: [
        { label: "Male", value: "male" },
        { label: "Female", value: "female" },
        { label: "Other", value: "other" },
      ],
    };
  },
  watch: {
    value(newValue) {
      this.selectedOption = newValue;
    },
  },
  methods: {
    updateSelection(val) {
      if (this.selectedOption === "Select gender") this.selectedOption === val;
      if (this.selectedOption !== null) {
        this.$emit("input", this.selectedOption);
      }
    },
    get placeholderText() {
      return this.placeholder ? this.placeholder : "Select gender";
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-multiselect-style
  .multiselect.multiselect--active
  .multiselect__select::before {
  top: -3% !important;
}
.custom-multiselect-disabled {
  opacity: 0.6 !important;
  border-radius: 10px;
  background: rgba(143, 144, 155, 0.85) !important;
}
.multiselect {
  min-height: 35px !important;
  height: auto !important;
}
.custom-multiselect-style .multiselect.multiselect--disabled {
  opacity: 0.6 !important;
  border-radius: 10px;
  background: rgba(143, 144, 155, 0.85) !important;
}
.custom-multiselect-style::v-deep .multiselect {
  &.multiselect--active {
    .multiselect__tags,
    .multiselect__content-wrapper {
      @apply border-primary;
    }
  }
  .multiselect__tags-wrap .multiselect__tag {
    background-color: #f2b7051a;
    border: 1px solid transparent;
    border-radius: 9999px;
    padding: 0.125rem 0.5rem;
    height: auto;
    display: inline-flex;
    align-items: center;
    color: black;
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
    margin-top: 0.125rem;
  }
  .multiselect__tags-wrap .multiselect__tag:hover {
    border: 1px solid #f2b705;
  }
  .multiselect__tag-icon:hover {
    background-color: #f2b7051a;
  }
  .multiselect__tag-icon {
    position: relative !important;
    width: auto;
    font-size: 14px;
    font-weight: 400;
    margin-left: 7px !important;
  }
  .multiselect__tag-icon:after {
    color: black !important;
  }
  .multiselect__placeholder,
  .multiselect__input,
  .multiselect__single {
    display: block !important;
    // padding-top: 0.25rem !important;
    line-height: normal;
    height: auto !important;
    min-height: 24px !important;
    @apply text-low;
  }

  &.error {
    .multiselect__tags {
      border-color: rgba(248, 180, 180, 1) !important;
      box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45) !important;
    }
    .multiselect__placeholder {
      color: rgba(155, 28, 28, 1) !important;
    }
  }

  .multiselect__tags-wrap {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-right: 35px;
    @apply flex flex-wrap;
  }

  .multiselect__input:focus::placeholder {
    color: #adadad !important;
  }

  .multiselect__option {
    font-size: 14px !important;
  }
  .multiselect__option--highlight {
    // background-color: #1eb5f0 !important;
    &.multisecelt__option--selected {
      background-color: rgb(223, 49, 49) !important;
    }
  }
  .fullWidthInput {
    width: 100% !important;
  }
  .multiselect__tags-wrap {
    width: auto;
  }
  .multiselect__option.multiselect__option--group {
    background-color: #e40089 !important;
    color: white !important;
  }
  .placeholder-italic::placeholder {
    font-style: italic !important;
    font-weight: 100;
  }
  .tag-margin {
    margin-bottom: 8px !important;
    margin-right: 8px !important;
  }
  .multiselect__element .multiselect__option {
    font-size: 16px !important;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.88) !important;
  }
  .multiselect__option {
    color: rgba(0, 0, 0, 0.88) !important;
    min-width: max-content;
  }

  .multiselect__option:hover > span {
    font-weight: 500;
  }
  .multiselect__element {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.88);
  }
  // .multiselect , .multiselect__tags {
  //    min-height: 34px !important;
  // }
  .multiselect__tags {
    position: relative;
    border: none !important;
    height: auto !important;
    padding: 2.4px 43px 3px 3px;
    @apply appearance-none block w-full border border-gray-300 transition duration-150 ease-in-out rounded;
    &:focus {
      @apply outline-none border-primary;
    }

    .multiselect__single {
      color: black !important;
    }

    .multiselect__tags:hover .multiselect__placeholder {
      color: rgba(0, 0, 0, 0.88);
    }
    input.multiselect__input.focus-visible {
      font-family: Nunito, sans-serif !important;
      padding-left: 0 !important;
      padding-top: 3px !important;
      width: 90% !important;
      @apply text-low;
      @apply bg-primary-color;
    }
  }
  .multiselect.multiselect--disabled .multiselect__input {
    height: auto !important;
    background-color: transparent;
  }
  .customWidthInput {
    width: auto !important;
  }
  .multiselect__tag-icon:focus,
  .multiselect__tag-icon:hover,
  .multiselect__element:active {
    width: 100% !important;
    width: -moz-available;
    width: -webkit-fill-available;
    width: fill-available;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.88);
  }

  .multiselect__content-wrapper {
    @apply max-h-full overflow-y-auto flex;
    border: transparent;
    border-radius: 10px;
    margin-top: 12px;
    scrollbar-color: #dedfe6 #f5f5f5 !important;
    scrollbar-width: thin !important;
    box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
      0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 9px 28px 8px rgba(0, 0, 0, 0.05);

    &::-webkit-scrollbar-track {
      background-color: #f5f5f5 !important;
    }

    &::-webkit-scrollbar {
      width: 4px !important;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #dedfe6 !important;
    }
  }

  .multiselect__input,
  .multiselect__single {
    background-color: inherit !important;
  }
  .multiselect__tags {
    background-color: transparent;
  }
  .multiselect__strong {
    border-radius: 93.571px;
    background: rgba(242, 183, 5, 0.15);
    color: #010a11;
    font-weight: 400;
    font-size: 14px;
    padding: 3px 6px;
    margin-right: 17px;
    position: absolute;
    top: 6px;
    right: 26px;
    &:hover {
      border: 1px solid #f2b705;
    }
  }
}

.placeholder-italic {
  background-color: white;
  border-radius: 10px;
  border: 0.5px solid rgba(168, 174, 184, 0.5);
  height: min-content;
  // min-height: 42px;
  width: max-content;
}
.customWidthInput,
.multiselect__custom {
  width: auto !important;
}
.customFullWidthInput {
  width: 100% !important;
}
.customWidthMax {
  width: max-content !important;
}
.customHeightInput {
  min-height: 63px;
}
.placeholder-italic:hover {
  border: 0.5px solid rgba(168, 174, 184, 0.5);
  background: rgba(242, 183, 5, 0.1) !important;
}
.customHoverEffect:hover {
  border: 0.5px solid rgba(168, 174, 184, 0.5) !important;
  background: #fff !important;
}
.smallHeight .multiselect {
  height: auto !important;
  min-height: 32px !important;
}
.smallHeight::v-deep {
  .multiselect .multiselect__input,
  .multiselect .multiselect__single,
  .multiselect .multiselect__placeholder {
    padding-top: 7px !important;
  }
  .multiselect,
  .multiselect .multiselect__tags {
    min-height: 32px !important;
    height: auto;
  }
  .multiselect .multiselect__tags {
    padding-top: 0px !important;
    padding: 0px 43px 0px 3px !important;
  }
  .multiselect--active .multiselect__select {
    top: -3px !important;
  }
  .multiselect .multiselect__select:after {
    top: 42% !important;
    color: #717986;
  }
  .multiselect__tags-wrap > span {
    padding: 3px 6px !important;
    margin: 5px 8px 4px 8px !important;
    font-size: 13.1px;
    font-style: normal;
    font-weight: 400;
    line-height: 15.72px;
  }
}
@media screen and (max-width: 640px) {
  .multiselect__content-wrapper {
    max-width: --webkit-fill-available;
  }
}
.clientWidth {
  width: auto !important;
}
.clientWidth .multiselect .multiselect__tags {
  min-height: 35px !important;
}
</style>
